import {
  CustomerDetailsQuery,
  useCustomerDetailsQuery,
} from "@dashboard/graphql";
import React, { createContext } from "react";

export interface CustomerDetailsProviderProps {
  id: string;
}

interface CustomerDetailsConsumerProps {
  customer: CustomerDetailsQuery | null;
  loading: boolean | null;
  refetch: () => void;
}

export const CustomerDetailsContext =
  createContext<CustomerDetailsConsumerProps>(null);

export const CustomerDetailsProvider: React.FC<
  CustomerDetailsProviderProps
> = ({ children, id }) => {
  const { data, loading, refetch } = useCustomerDetailsQuery({
    displayLoader: true,
    variables: {
      id,
    },
  });

  const providerValues: CustomerDetailsConsumerProps = {
    customer: data,
    loading,
    refetch,
  };

  return (
    <CustomerDetailsContext.Provider value={providerValues}>
      {children}
    </CustomerDetailsContext.Provider>
  );
};
